import { useState } from 'react';
import Lottie from 'lottie-react-web';
import loadingAnimation from './loading.json';

const FormSection = ({ generateResponse, isLoading }) => {
  const [question1, setQuestion1] = useState('');
  const [question2, setQuestion2] = useState(''); 
  const [isLoadingResponse, setIsLoadingResponse] = useState(false);

  const handleSubmit = () => {
    const newQuestion = `${question1} ${question2}`;
    if (newQuestion.trim().length === 0 || isLoading || isLoadingResponse) {
      return; // Возвращаем функцию, если вопрос пустой или уже загружается ответ
    }
    setIsLoadingResponse(true);
    generateResponse(newQuestion, () => {
      setQuestion1('');
      setQuestion2(''); 
      setIsLoadingResponse(false);
    });
  };

  return (
    <div className="form-section">
      {isLoadingResponse ? (
        <div className="loading-animation">
          <Lottie
            options={{
              animationData: loadingAnimation,
              loop: true,
            }}
            width={350}
            height={350}
          />
        </div>
      ) : (
        <>
          <textarea
            rows="3"
            className="form-control"
            placeholder="Напишите здесь, кого вы хотите поздравить. Например: коллег; друзей; клиентов; подписчиков..."
            value={question1}
            onChange={(e) => setQuestion1(e.target.value)}
          />
          <textarea
            rows="3"
            className="form-control"
            placeholder="Напишите сюда, в каком стиле поздравление. Например: юмористический; мудрый; сдержанный; волшебный..."
            value={question2}
            onChange={(e) => setQuestion2(e.target.value)}
          /> 
        </>
      )}
      <button
        className={`btn ${isLoadingResponse ? 'btn-disabled' : ''}`}
        onClick={handleSubmit}
        disabled={isLoading || isLoadingResponse}
      >
        {isLoadingResponse ? 'ГЕНЕРИРУЮ ОТВЕТ' : 'ПОЛУЧИТЬ ОТВЕТ'}
      </button>
    </div>
  );
};

export default FormSection;